import React from "react";
import GlobalNav from "../components/GlobalNav";
import Footer from "../components/Footer";
import "../styles/buttons.css";
import "./ProgramsPage.css";

// PLACEHOLDER copy — I don't have real descriptions for these three
// programs (no SoulSessions.jsx source, no Storytime content anywhere in
// this conversation), so these blurbs are reasonable-sounding but
// invented. Replace with real copy when you have it. Soul Sessions
// already has a real route (/soulsessions, per App.js); Storytime and
// Radio don't have dedicated pages yet, so their CTAs are omitted rather
// than linking somewhere fake.
const PROGRAMS = [
  {
    key: "soul-sessions",
    title: "Soul Sessions",
    blurb: "Intimate live performances and open-mic gatherings centered on healing through shared sound.",
    href: "/soulsessions",
    ctaLabel: "Explore Soul Sessions",
  },
  {
    key: "storytime",
    title: "Storytime",
    blurb: "An interactive session featuring African drumming, rhythmic movement, and multimodal storytelling designed to enhance early literacy, socio-emotional, and STEAM skills.",
    href: "/storytime",
    ctaLabel: "Attend Storytime",
  },
  {
    key: "radio",
    title: "Music Is Healing Radio",
    blurb: "Live every Wednesday at 8pm on WBCA 102.9FM, Boston's community radio station. Hosted by kwe.",
    href: "/radio",
    ctaLabel: "Tune in",
  },
];

export default function ProgramsPage() {
  return (
    <div className="programs-page">
      <GlobalNav activeHref="/programs" ctaLabel="Join the collective" />

      {/* <div className="programs-hero">
        <div className="programs-hero-inner">
          <div className="programs-hero-eyebrow">What we run</div>
          <h1 className="programs-hero-title">Programs</h1>
          <p className="programs-hero-sub">
            Ongoing community programs rooted in the four pillars of wellness —
            separate from the calendar of one-off events.
          </p>
        </div>
      </div> */}

      <div className="programs-body">
        <div className="programs-grid">
          {PROGRAMS.map((p) => (
            <div className="programs-card" key={p.key}>
              <h2 className="programs-card-title">{p.title}</h2>
              <p className="programs-card-blurb">{p.blurb}</p>
              {p.href ? (
                <a className="mihu-btn-primary-lg programs-card-cta" href={p.href}>
                  {p.ctaLabel}
                </a>
              ) : (
                <span className="programs-card-soon">More info coming soon</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
